import {
    EnvironmentProviders,
    InjectionToken,
    makeEnvironmentProviders,
    Type,
} from '@angular/core';
import { ISbConfig } from 'storyblok-js-client';
import { StoryblokRichTextOptions } from '@storyblok/richtext';

export interface CmsComponents<C = unknown> {
    [key: string]: Type<C>;
}

/**
 * The storyblok config (included token, if not default an endpoint and some more storyblok settings)
 * */
export interface StoryblokConfig extends ISbConfig {
    /** storyblok token with it's permissions */
    accessToken: string;
    /** slug for the layout story */
    layoutStorySlug: string;
    /** configured components to use in storyblok */
    components: CmsComponents;
    /** endpoint url, only set if not a default region depending api endpoint */
    endpoint?: string;
    /** if https should be used (only use http in development) */
    https?: boolean;
    /** the region, you use your storyblok in (if non is selected, `eu` is default) */
    region?: 'eu' | 'us' | 'cn' | 'ap' | 'ca';
    /** version of the fetched data (published or draft) - be aware, that your token  has to allow draft versions */
    version?: 'draft' | 'published';
    /** rich text resolver configuration */
    richText?: StoryblokRichTextOptions<string>;
}

export const STORYBLOK_CONFIG = new InjectionToken<StoryblokConfig>(
    'Storyblok config',
    {
        factory: () => ({
            components: {},
            accessToken: '',
            layoutStorySlug: '/layout',
        })
    }
);

export function provideStoryblok(
    config: StoryblokConfig,
): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: STORYBLOK_CONFIG, useValue: config },
    ]);
}
